/** @format */

import de from './translations/de'
import rus from './translations/rus'
export default {
  de,
  rus,
}
